import { Injectable } from '@angular/core';
import { BankLimitsResponse } from '@interfaces/bank-limits/responses/bank-limits.response';
import { VaultApiService } from '@services/api/vault-api.service';
import { Observable } from 'rxjs';

/**
 * Limites bancários de uma empresa para o card "Limites Bancários" da Home (card 3786).
 * Permissão `BANKRELATIONSHIP_LIST`; empresa fora do escopo do usuário volta 404.
 */
@Injectable({
  providedIn: 'root',
})
export class BankLimitsHttpService {
  private readonly BASE_URL = 'dashboard/bank-limits';

  constructor(private readonly apiService: VaultApiService) {}

  /** Total disponível de 4131 e a situação de cada banco com relacionamento cadastrado. */
  getByCompany(companyId: string): Observable<BankLimitsResponse | null> {
    return this.apiService.get<BankLimitsResponse>(this.BASE_URL, undefined, { companyId });
  }
}
